import { RG_TYPE } from "@project-rouge/rg-core";
var DEFAULT_DOOR_WIDTH = 1.3;
function getEntranceDoorWidth(unit) {
	let entryWidth = DEFAULT_DOOR_WIDTH;
	if (unit.type === RG_TYPE.Apartment) entryWidth = getApartmentEntryDoorWidth(unit);
	else if (unit.type === RG_TYPE.Core || unit.type === RG_TYPE.Entrance) entryWidth = getCoreEntryDoorWidth(unit);
	return entryWidth;
}
function getApartmentEntryDoorWidth(apt) {
	for (const module of apt.children.filter((c) => c.type === RG_TYPE.Module)) for (const wall of module.children.filter((c) => c.type === RG_TYPE.Wall)) {
		const door = wall.children.find((c) => c.type === RG_TYPE.Door && c.data.isEntrance);
		if (door) return door.size[0];
	}
	return DEFAULT_DOOR_WIDTH;
}
function getCoreEntryDoorWidth(unit) {
	for (const wall of unit.children.filter((c) => c.type === RG_TYPE.Wall)) {
		const door = wall.children.find((c) => c.type === RG_TYPE.Door && c.data.isEntrance);
		if (door) return door.size[0];
	}
	return DEFAULT_DOOR_WIDTH;
}
export { getEntranceDoorWidth };

//# sourceMappingURL=index159.js.map